import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatCurrency(value, decimals = 2) {
  if (value === null || value === undefined) return '-';
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(value);
}

export function formatNumber(value, decimals = 0) {
  if (value === null || value === undefined) return '-';
  return new Intl.NumberFormat('en-US', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(value);
}

export function formatDate(dateString) {
  if (!dateString) return '-';
  return new Date(dateString).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
}

export function formatDateTime(dateString) {
  if (!dateString) return '-';
  return new Date(dateString).toLocaleString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function getStatusColor(status) {
  switch (status) {
    case 'BELOW':
      return 'bg-emerald-100 text-emerald-800 border-emerald-200';
    case 'IN_RANGE':
      return 'bg-blue-100 text-blue-800 border-blue-200';
    case 'ABOVE':
      return 'bg-red-100 text-red-800 border-red-200';
    case 'NO_DATA':
    case 'NO_TARGET':
      return 'bg-gray-100 text-gray-600 border-gray-200';
    default:
      return 'bg-gray-100 text-gray-600 border-gray-200';
  }
}

export function getStatusLabel(status) {
  switch (status) {
    case 'BELOW':
      return 'Below Target';
    case 'IN_RANGE':
      return 'In Range';
    case 'ABOVE':
      return 'Above Target';
    case 'NO_DATA':
      return 'No Data';
    case 'NO_TARGET':
      return 'No Target';
    default:
      return status;
  }
}

export function getApprovalStatusColor(status) {
  switch (status) {
    case 'APPROVED':
      return 'bg-emerald-100 text-emerald-800';
    case 'REJECTED':
      return 'bg-red-100 text-red-800';
    case 'PENDING':
      return 'bg-amber-100 text-amber-800';
    case 'NOT_REQUIRED':
      return 'bg-gray-100 text-gray-600';
    default:
      return 'bg-gray-100 text-gray-600';
  }
}

export function hasPermission(user, permission) {
  if (!user || !user.permissions) return false;
  return user.permissions[permission] === true;
}

export function getTodayDateString() {
  return new Date().toISOString().split('T')[0];
}
